export default __webpack_public_path__ + "static/media/komi.d97f6222.md";